import { toastBaseAlert } from "@/alerts/toastBaseAlert";

/*** Displays an info toast
 * @param text message to be displayed
 * @param displayTime defines how long the toast is displayed in milliseconds. This is set to 6000 by default */
export default function displayInfoToast(
  text: string,
  displayTime: number = 6000,
) {
  return toastBaseAlert.fire({
    text: text,
    icon: "info",
    timer: displayTime,
    background: "#4BAAEF",
  });
}
